module.exports = __webpack_public_path__ + "img/beijing_cbd.3fa7f59f.png";